import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo, forwardRef, useCallback } from "react";
import { useComponentClassName } from "../../auxiliary/useComponentClassName.js";
import { toStateClass } from "../../utils/toStateClass.js";
const MenuExpandToggle = memo(forwardRef(({
  controls,
  checked,
  disabled,
  onChange
}, ref) => {
  const componentClassName = useComponentClassName("menu-expand-toggle");
  return /* @__PURE__ */ jsx(
    "button",
    {
      tabIndex: -1,
      ref,
      type: "button",
      disabled,
      className: classNames(
        componentClassName,
        toStateClass("collapsed", !checked)
      ),
      "aria-haspopup": "true",
      "aria-controls": controls,
      "aria-expanded": checked,
      onClick: useCallback(() => {
        onChange(!checked);
      }, [checked, onChange]),
      onKeyPress: useCallback((event) => {
        switch (event.code) {
          case "ArrowRight":
            onChange(true);
            break;
          case "ArrowLeft":
            onChange(false);
            break;
        }
      }, [onChange]),
      children: /* @__PURE__ */ jsx("span", { className: `${componentClassName}-label`, children: checked ? "-" : "+" })
    }
  );
}));
export {
  MenuExpandToggle
};
//# sourceMappingURL=ExpandToggle.js.map
